import React from "react";
import {useTranslation} from "react-i18next";
import Table from "@awsui/components-react/table";
import Box from "@awsui/components-react/box";
import Header from "@awsui/components-react/header";


interface PointsItem {
    position: number;
    points: number;
}

interface PointsTableProps {
    title: string;
    points: number[];
}

const PointsTable: React.FC<PointsTableProps> = (props) => {
    const {t} = useTranslation("about");
    return (
        <Table
            columnDefinitions={[
                {
                    id: "position",
                    header: t("columns.position"),
                    cell: (item: PointsItem) => item.position || "-",
                    sortingField: "position"
                },
                {
                    id: "points",
                    header: t("columns.points"),
                    cell: (item: PointsItem) => item.points || "-",
                    sortingField: "position"
                }
            ]}
            items={props.points.map((value: number, index: number) => {
                return {
                    position: index + 1,
                    points: value
                };
            })}
            loadingText={t("loading")}
            sortingDisabled
            variant="full-page"
            empty={
                <Box textAlign="center" color="inherit">
                    <Box
                        padding={{ bottom: "s" }}
                        variant="p"
                        color="inherit"
                    >
                        {t("empty")}
                    </Box>
                </Box>
            }
            header={<Header>{props.title}</Header>}
        />
    );
};

export default PointsTable;
